import * as React from 'react';
export const upiSvg = React.forwardRef(function upiSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F6F8FA',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm18.658 2.5 6.645 13.25L11.33 29l7.328-26.5Z',
      fill: '#098041',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm13.988 2.5 6.646 13.25L6.648 29l7.34-26.5Z',
      fill: '#E97626',
    }),
  );
});
upiSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var upi = {
  category: 'brand',
  colorable: false,
  name: 'upi',
  svg: upiSvg,
};
